"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMarginStyles = exports.buildSlotStyle = exports.buildSelector = exports.buildContent = exports.toInlineStyles = exports.toInlineStylePart = exports.toQuotedCssVarValue = exports.marginVarToValue = exports.marginVarToKey = void 0;
const types_1 = require("./types");
const util_1 = require("../util");
// turn sleneName into --slene-name
const marginVarToKey = (mv) => `--${(0, util_1.camelToKebab)(mv)}`;
exports.marginVarToKey = marginVarToKey;
// turn sleneName into var(--slene-name)
const marginVarToValue = (mv) => `var(${(0, exports.marginVarToKey)(mv)})`;
exports.marginVarToValue = marginVarToValue;
const toQuotedCssVarValue = (input) => JSON.stringify(String(input));
exports.toQuotedCssVarValue = toQuotedCssVarValue;
// this takes a marginVariable and a string or number value and converts it to
// an inline style fragment... like ('sleneNumber', 4) becomes --slene-number:"4"
const toInlineStylePart = (mv, value) => `${(0, exports.marginVarToKey)(mv)}:${(0, exports.toQuotedCssVarValue)(value)}`;
exports.toInlineStylePart = toInlineStylePart;
const toInlineStyles = (mvData) => {
    const parts = [];
    for (const mv of types_1.ZMarginVariablesEnum.options) {
        const value = mvData[mv];
        if (typeof value === 'string' || typeof value === 'number') {
            parts.push((0, exports.toInlineStylePart)(mv, value));
        }
    }
    if (parts.length > 0) {
        parts.push(';');
    }
    return parts.join(';');
};
exports.toInlineStyles = toInlineStyles;
const buildContent = (input) => {
    const parts = input.map((item) => {
        return Array.isArray(item) ? (0, exports.marginVarToValue)(item[0]) : `'${item}'`;
    });
    return parts.join(' ');
};
exports.buildContent = buildContent;
// transform ('doc', [1, 2]) into .o-page:not([data-doc-page='1']):not([data-doc-page='2'])
const buildExclusionSelector = (key, pages) => {
    const parts = ['.o-page'];
    const attributeKey = `data-${key}-page`;
    pages.forEach((pageNum) => {
        parts.push(`:not([${attributeKey}='${pageNum}'])`);
    });
    return parts.join('');
};
const buildExclusionSelectors = (config) => {
    const parts = [];
    Object.entries(config).forEach(([countedType, pagesToExclude]) => {
        parts.push(buildExclusionSelector(countedType, pagesToExclude));
    });
    return parts.join('');
};
// this builds a css selector for a single quadrant that has
// unconditional rendering
// e.g. [data-margin-slot='top-left'] div:nthChild(0)
const buildSelector = (pagePosition, quadrantRowIndex, side, exclusions) => {
    const parts = [];
    if (exclusions) {
        parts.push(buildExclusionSelectors(exclusions));
    }
    // start with [data-margin-slot='top-left']
    parts.push(`[data-margin-slot='${(0, util_1.camelToKebab)(pagePosition)}']`);
    // nth child: e.g. div:nthChild(1)
    const nthChild = `div:nth-child(${quadrantRowIndex + 1})`;
    // with it's pseudo-element
    parts.push(`${nthChild}::${side}`);
    // join with spaces
    return parts.join(' ');
};
exports.buildSelector = buildSelector;
const buildSlotStyle = ({ content, styles, }) => {
    return {
        content: (0, exports.buildContent)(content),
        ...styles,
    };
};
exports.buildSlotStyle = buildSlotStyle;
const makeMarginStyles = (margins, docLevelVars) => {
    // set all margin variables at the top-- use the value passed in
    // or set to '' as a default value-- (css barfs if you try to dereference
    // a var that wasn't set)
    const docStyles = {};
    types_1.ZMarginVariablesEnum.options.forEach((mv) => {
        const value = docLevelVars[mv] || '';
        docStyles[(0, exports.marginVarToKey)(mv)] = (0, exports.toQuotedCssVarValue)(value);
    });
    const result = {
        '.ProseMirror': docStyles,
    };
    types_1.ZMarginSlotPosition.options.forEach((position) => {
        const slotConfig = margins[position];
        if (slotConfig) {
            const upperBefore = slotConfig[0][0];
            const upperAfter = slotConfig[0][1];
            const lowerBefore = slotConfig[1] ? slotConfig[1][0] : undefined;
            const lowerAfter = slotConfig[1] ? slotConfig[1][1] : undefined;
            if (upperBefore) {
                result[(0, exports.buildSelector)(position, 0, 'before', upperBefore.exclusions)] =
                    (0, exports.buildSlotStyle)(upperBefore);
            }
            if (upperAfter) {
                result[(0, exports.buildSelector)(position, 0, 'after', upperAfter.exclusions)] =
                    (0, exports.buildSlotStyle)(upperAfter);
            }
            if (lowerBefore) {
                result[(0, exports.buildSelector)(position, 1, 'before', lowerBefore.exclusions)] =
                    (0, exports.buildSlotStyle)(lowerBefore);
            }
            if (lowerAfter) {
                result[(0, exports.buildSelector)(position, 1, 'after', lowerAfter.exclusions)] =
                    (0, exports.buildSlotStyle)(lowerAfter);
            }
        }
    });
    return result;
};
exports.makeMarginStyles = makeMarginStyles;
